import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "payee_entry"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { class: "normal" };
const _hoisted_6 = {
    key: 0,
    class: "history-section",
    style: { "margin-top": "20px" }
};
const _hoisted_7 = { style: { "cursor": "pointer" } };
const _hoisted_8 = { style: { "font-weight": "bold", "color": "#1991b4", "margin-bottom": "10px" } };
const _hoisted_9 = {
    class: "history-list",
    style: { "background-color": "#f8f9fa", "padding": "15px", "border-radius": "5px" }
};
const _hoisted_10 = { style: { "font-size": "14px", "color": "#666" } };
const _hoisted_11 = { style: { "margin": "5px 0" } };
const _hoisted_12 = {
    key: 0,
    style: { "font-size": "12px", "color": "#888" }
};
const _hoisted_13 = {
    id: "receive-modal",
    class: "modal min2 js-modal"
};
const _hoisted_14 = { class: "modal-content" };
const _hoisted_15 = { class: "close_bt bt_modal_close" };
const _hoisted_16 = { class: "pop" };
const _hoisted_17 = { class: "center" };
const _hoisted_18 = { class: "bt_box clear" };
const _hoisted_19 = {
    id: "withholding-modal",
    class: "modal min2 js-modal"
};
const _hoisted_20 = { class: "modal-content" };
const _hoisted_21 = { class: "close_bt bt_modal_close" };
const _hoisted_22 = { class: "pop" };
const _hoisted_23 = { class: "sec_2 last" };
const _hoisted_24 = {
    key: 0,
    class: "err"
};
const _hoisted_25 = { class: "bt_box clear" };
const _hoisted_26 = {
    id: "bank-modal",
    class: "modal type3 js-modal"
};
const _hoisted_27 = { class: "modal-content" };
const _hoisted_28 = { class: "close_bt bt_modal_close" };
const _hoisted_29 = { class: "pop" };
const _hoisted_30 = { class: "sec_2 last" };
const _hoisted_31 = {
    key: 0,
    class: "err"
};
const _hoisted_32 = {
    key: 1,
    class: "err"
};
const _hoisted_33 = {
    key: 2,
    class: "err"
};
const _hoisted_34 = {
    key: 3,
    class: "err"
};
const _hoisted_35 = {
    key: 4,
    class: "err"
};
const _hoisted_36 = {
    key: 5,
    class: "err"
};
const _hoisted_37 = {
    key: 6,
    class: "err"
};
import { ref, reactive, watch, computed, onMounted, nextTick } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import ImageFrame from '@component/ImageFrame.vue';
import { PayeeUpdatedType } from '@util/Consts';
import { isObjEmpty } from '@util/Common';
export default /*@__PURE__*/ _defineComponent({
    __name: 'payee_entry',
    props: {
        common: {},
        errors: {},
        payee: {},
        withholdingTaxHistory: {}
    },
    setup(__props) {
        var _a, _b, _c, _d;
        const props = __props;
        const form = reactive({
            update_type: PayeeUpdatedType.PAYEE,
            user_id: props.common.user_id,
            receive: (_a = props.payee.receive) !== null && _a !== void 0 ? _a : true,
            is_professional: (_b = props.payee.is_professional) !== null && _b !== void 0 ? _b : null,
            bank_code: props.payee.bank_code,
            institution_name: props.payee.institution_name,
            branch_code: props.payee.branch_code,
            branch_name: props.payee.branch_name,
            account_type: props.payee.account_type,
            account_number: props.payee.account_number.toString(),
            account_holder: props.payee.account_holder,
        });
        const tempForm = reactive({
            update_type: PayeeUpdatedType.PAYEE,
            user_id: props.common.user_id,
            receive: (_c = props.payee.receive) !== null && _c !== void 0 ? _c : true,
            is_professional: (_d = props.payee.is_professional) !== null && _d !== void 0 ? _d : null,
            bank_code: props.payee.bank_code,
            institution_name: props.payee.institution_name,
            branch_code: props.payee.branch_code,
            branch_name: props.payee.branch_name,
            account_type: props.payee.account_type,
            account_number: props.payee.account_number.toString(),
            account_holder: props.payee.account_holder,
        });
        // const showReceived = computed(() => {
        //     return form.receive ? '受け取る' : '受け取らない';
        // });
        const showTypeName = computed(() => {
            return form.account_type === 1 ? '普通' : '当座';
        });
        const showAccountCode = computed(() => {
            var _a, _b;
            if (!(form === null || form === void 0 ? void 0 : form.account_number)) {
                return '';
            }
            const partition = -3;
            const end = (_a = form === null || form === void 0 ? void 0 : form.account_number) === null || _a === void 0 ? void 0 : _a.slice(partition);
            const start = (_b = form === null || form === void 0 ? void 0 : form.account_number) === null || _b === void 0 ? void 0 : _b.slice(0, partition);
            return `${start.replace(/[0-9]/g, '*')}${end}`;
        });
        const showWithholdingTax = computed(() => {
            if (form.is_professional === null) {
                return '未設定';
            }
            return form.is_professional === 1 ? 'はい' : 'いいえ';
        });
        watch(() => tempForm.bank_code, () => {
            const pattern = /[^0-9]/g;
            tempForm.bank_code = tempForm.bank_code.replace(pattern, '');
        });
        watch(() => tempForm.branch_code, () => {
            const pattern = /[^0-9]/g;
            tempForm.branch_code = tempForm.branch_code.replace(pattern, '');
        });
        watch(() => tempForm.account_number, () => {
            const pattern = /[^0-9]/g;
            tempForm.account_number = tempForm.account_number.replace(pattern, '');
        });
        // 文字数チェック
        watch(() => tempForm.institution_name, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.institution_name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.branch_name, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.branch_name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => tempForm.account_holder, (value) => {
            if (Alert.charLimitText(value)) {
                tempForm.account_holder = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        const onClickReceiveCancel = () => {
            tempForm.receive = form.receive;
        };
        const onClickCancel = () => {
            tempForm.bank_code = form.bank_code;
            tempForm.institution_name = form.institution_name;
            tempForm.branch_code = form.branch_code;
            tempForm.branch_name = form.branch_name;
            tempForm.account_type = form.account_type;
            tempForm.account_number = form.account_number;
            tempForm.account_holder = form.account_holder;
            tempForm.is_professional = form.is_professional;
            validate.shot = false;
        };
        const onClickReceiveOk = () => {
            form.receive = tempForm.receive;
        };
        const close = ref();
        const validate = reactive({ shot: false });
        const onClickOk = () => {
            form.bank_code = tempForm.bank_code;
            form.institution_name = tempForm.institution_name;
            form.branch_code = tempForm.branch_code;
            form.branch_name = tempForm.branch_name;
            form.account_type = tempForm.account_type;
            form.account_number = tempForm.account_number;
            form.account_holder = tempForm.account_holder;
            form.is_professional = tempForm.is_professional;
            Inertia.post(route('mentor.payee.update'), Object.assign({}, form), {
                onSuccess: () => {
                    close.value.click();
                },
                onError: () => { validate.shot = true; }
            });
        };
        onMounted(() => {
            validate.shot = isObjEmpty(props.errors);
            nextTick(() => {
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
            });
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[24] || (_cache[24] = _createElementVNode("h2", null, "振込先登録", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("dl", _hoisted_5, [
                                    _cache[22] || (_cache[22] = _createElementVNode("dt", null, [
                                        _createTextVNode(" 源泉徴収"),
                                        _createElementVNode("br", { class: "pc" }),
                                        _createElementVNode("span", { class: "must" }, "必須"),
                                        _createElementVNode("span", { class: "non_public" }, "非公開"),
                                        _createElementVNode("a", {
                                            class: "bt_change modal_win sp",
                                            "data-target": "withholding-modal"
                                        }, "変更")
                                    ], -1)),
                                    _createElementVNode("dd", null, [
                                        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "sub_t" }, "源泉徴収対象者ですか？", -1)),
                                        _createTextVNode(" " + _toDisplayString(showWithholdingTax.value) + " ", 1),
                                        _cache[15] || (_cache[15] = _createElementVNode("a", {
                                            class: "bt_change modal_win pc",
                                            "data-target": "withholding-modal"
                                        }, "変更", -1)),
                                        (props.withholdingTaxHistory && props.withholdingTaxHistory.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                _createElementVNode("details", _hoisted_7, [
                                                    _createElementVNode("summary", _hoisted_8, " 変更履歴 (" + _toDisplayString(props.withholdingTaxHistory.length) + "件) ", 1),
                                                    _createElementVNode("div", _hoisted_9, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.withholdingTaxHistory, (history, index) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: index,
                                                                style: { "border-bottom": "1px solid #dee2e6", "padding": "10px 0", "margin-bottom": "10px" }
                                                            }, [
                                                                _createElementVNode("div", _hoisted_10, _toDisplayString(new Date(history.created_at).toLocaleDateString('ja-JP')) + " " + _toDisplayString(new Date(history.created_at).toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' })), 1),
                                                                _createElementVNode("div", _hoisted_11, [
                                                                    _cache[12] || (_cache[12] = _createElementVNode("span", { style: { "font-weight": "bold" } }, "変更前:", -1)),
                                                                    _createTextVNode(" " + _toDisplayString(history.old_value_display) + " ", 1),
                                                                    _cache[13] || (_cache[13] = _createElementVNode("span", { style: { "margin-left": "15px", "font-weight": "bold" } }, "変更後:", -1)),
                                                                    _createTextVNode(" " + _toDisplayString(history.new_value_display), 1)
                                                                ]),
                                                                (history.reason)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 理由: " + _toDisplayString(history.reason), 1))
                                                                    : _createCommentVNode("", true)
                                                            ]));
                                                        }), 128))
                                                    ])
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _cache[23] || (_cache[23] = _createElementVNode("dt", null, [
                                        _createTextVNode(" 振込先"),
                                        _createElementVNode("br", { class: "pc" }),
                                        _createElementVNode("span", { class: "must" }, "必須"),
                                        _createElementVNode("span", { class: "non_public" }, "非公開"),
                                        _createElementVNode("a", {
                                            class: "bt_change modal_win sp",
                                            "data-target": "bank-modal"
                                        }, "変更")
                                    ], -1)),
                                    _createElementVNode("dd", null, [
                                        _cache[16] || (_cache[16] = _createElementVNode("p", { class: "sub_t" }, "金融機関名", -1)),
                                        _createTextVNode(" " + _toDisplayString(form.institution_name) + " ", 1),
                                        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "sub_t" }, "支店名", -1)),
                                        _createTextVNode(" " + _toDisplayString(form.branch_name) + " ", 1),
                                        _cache[18] || (_cache[18] = _createElementVNode("p", { class: "sub_t" }, "種別", -1)),
                                        _createTextVNode(" " + _toDisplayString(showTypeName.value) + " ", 1),
                                        _cache[19] || (_cache[19] = _createElementVNode("p", { class: "sub_t" }, "口座名義", -1)),
                                        _createTextVNode(" " + _toDisplayString(form.account_holder) + " ", 1),
                                        _cache[20] || (_cache[20] = _createElementVNode("p", { class: "sub_t" }, "口座番号", -1)),
                                        _createTextVNode(" " + _toDisplayString(showAccountCode.value) + " ", 1),
                                        _cache[21] || (_cache[21] = _createElementVNode("a", {
                                            class: "bt_change modal_win pc",
                                            "data-target": "bank-modal"
                                        }, "変更", -1))
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("form", null, [
                            _createElementVNode("div", _hoisted_13, [
                                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "modal-bg bt_modal_close" }, null, -1)),
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                        _cache[27] || (_cache[27] = _createElementVNode("h2", null, "報酬", -1)),
                                        _createElementVNode("div", _hoisted_17, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tempForm.receive) = $event)),
                                                value: true,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q1",
                                                id: "q1_a1"
                                            }, null, 512), [
                                                [_vModelRadio, tempForm.receive]
                                            ]),
                                            _cache[25] || (_cache[25] = _createElementVNode("label", { for: "q1_a1" }, "受け取る", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((tempForm.receive) = $event)),
                                                value: false,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q1",
                                                id: "q1_a2"
                                            }, null, 512), [
                                                [_vModelRadio, tempForm.receive]
                                            ]),
                                            _cache[26] || (_cache[26] = _createElementVNode("label", {
                                                for: "q1_a2",
                                                style: { "margin-left": "6px" }
                                            }, "受け取らない", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("p", {
                                                        class: "bt_modal_close bt_clear",
                                                        onClick: onClickReceiveCancel
                                                    }, "キャンセル")
                                                ]),
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("p", {
                                                        class: "bt_ok",
                                                        onClick: onClickReceiveOk
                                                    }, "OK")
                                                ])
                                            ]),
                                            _createElementVNode("p", {
                                                class: "bt_modal_close",
                                                ref_key: "close",
                                                ref: close,
                                                style: { "display": "none" }
                                            }, null, 512)
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "modal-bg bt_modal_close" }, null, -1)),
                                _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                        _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                        _cache[34] || (_cache[34] = _createElementVNode("h2", null, "源泉徴収登録", -1)),
                                        _createElementVNode("div", _hoisted_23, [
                                            _cache[29] || (_cache[29] = _createElementVNode("p", { class: "sub_t" }, "源泉徴収対象者ですか？", -1)),
                                            _cache[30] || (_cache[30] = _createElementVNode("span", { class: "withholding-desc" }, [
                                                _createTextVNode("(弁護士、税理士、社会保険労務士等の士業の方。"),
                                                _createElementVNode("br"),
                                                _createTextVNode("対象者の場合、報酬から源泉所得税額を差し引いたうえでお振込します。)")
                                            ], -1)),
                                            _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((tempForm.is_professional) = $event)),
                                                value: 1,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q3_1",
                                                id: "q3_1_a1"
                                            }, null, 512), [
                                                [_vModelRadio, tempForm.is_professional]
                                            ]),
                                            _cache[32] || (_cache[32] = _createElementVNode("label", { for: "q3_1_a1" }, "はい", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((tempForm.is_professional) = $event)),
                                                value: 0,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q3_1",
                                                id: "q3_1_a2"
                                            }, null, 512), [
                                                [_vModelRadio, tempForm.is_professional]
                                            ]),
                                            _cache[33] || (_cache[33] = _createElementVNode("label", {
                                                for: "q3_1_a2",
                                                style: { "margin-left": "6px" }
                                            }, "いいえ", -1)),
                                            (validate.shot && ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.is_professional))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(props.errors.is_professional), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("p", {
                                                        class: "bt_modal_close bt_clear",
                                                        onClick: onClickCancel
                                                    }, "キャンセル")
                                                ]),
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("p", {
                                                        class: "bt_ok",
                                                        onClick: onClickOk
                                                    }, "OK")
                                                ])
                                            ]),
                                            _createElementVNode("p", {
                                                class: "bt_modal_close",
                                                ref_key: "close",
                                                ref: close,
                                                style: { "display": "none" }
                                            }, null, 512)
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", {
                                    class: "modal-bg bt_modal_close",
                                    onClick: onClickCancel
                                }),
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                        _createVNode(ImageFrame, {
                                            src: "images/common/i_bt_close.svg",
                                            onClick: onClickCancel
                                        })
                                    ]),
                                    _createElementVNode("div", _hoisted_29, [
                                        _cache[57] || (_cache[57] = _createElementVNode("h2", null, "振込先登録", -1)),
                                        _createElementVNode("div", _hoisted_30, [
                                            _cache[36] || (_cache[36] = _createElementVNode("p", { class: "sub_t" }, "金融機関コード", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((tempForm.bank_code) = $event)),
                                                type: "text",
                                                name: "q2_1",
                                                class: "w20 inquiry-form",
                                                maxlength: "4"
                                            }, null, 512), [
                                                [_vModelText, tempForm.bank_code]
                                            ]),
                                            _cache[37] || (_cache[37] = _createElementVNode("span", null, "（半角数字4桁）", -1)),
                                            _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
                                            (validate.shot && ((_b = props.errors) === null || _b === void 0 ? void 0 : _b.bank_code))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(props.errors.bank_code), 1))
                                                : _createCommentVNode("", true),
                                            _cache[39] || (_cache[39] = _createElementVNode("p", { class: "sub_t" }, "金融機関名", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((tempForm.institution_name) = $event)),
                                                type: "text",
                                                name: "q2_2",
                                                class: "w60 inquiry-form",
                                                placeholder: "例：みずほ銀行"
                                            }, null, 512), [
                                                [_vModelText, tempForm.institution_name]
                                            ]),
                                            _cache[40] || (_cache[40] = _createElementVNode("br", null, null, -1)),
                                            (validate.shot && ((_c = props.errors) === null || _c === void 0 ? void 0 : _c.institution_name))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(props.errors.institution_name), 1))
                                                : _createCommentVNode("", true),
                                            _cache[41] || (_cache[41] = _createElementVNode("p", { class: "sub_t" }, "支店コード", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((tempForm.branch_code) = $event)),
                                                type: "text",
                                                name: "q2_3",
                                                class: "w20 inquiry-form",
                                                maxlength: "3"
                                            }, null, 512), [
                                                [_vModelText, tempForm.branch_code]
                                            ]),
                                            _cache[42] || (_cache[42] = _createElementVNode("span", null, "（半角数字3桁）", -1)),
                                            _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
                                            (validate.shot && ((_d = props.errors) === null || _d === void 0 ? void 0 : _d.branch_code))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(props.errors.branch_code), 1))
                                                : _createCommentVNode("", true),
                                            _cache[44] || (_cache[44] = _createElementVNode("p", { class: "sub_t" }, "支店名", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((tempForm.branch_name) = $event)),
                                                type: "text",
                                                name: "q2_4",
                                                class: "f_corp wmax inquiry-form",
                                                placeholder: "例：品川支店"
                                            }, null, 512), [
                                                [_vModelText, tempForm.branch_name]
                                            ]),
                                            _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                                            (validate.shot && ((_e = props.errors) === null || _e === void 0 ? void 0 : _e.branch_name))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(props.errors.branch_name), 1))
                                                : _createCommentVNode("", true),
                                            _cache[46] || (_cache[46] = _createElementVNode("p", { class: "sub_t" }, "種別", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((tempForm.account_type) = $event)),
                                                value: 1,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q2_5",
                                                id: "q2_5_a1"
                                            }, null, 512), [
                                                [_vModelRadio, tempForm.account_type]
                                            ]),
                                            _cache[47] || (_cache[47] = _createElementVNode("label", { for: "q2_5_a1" }, "普通", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((tempForm.account_type) = $event)),
                                                value: 2,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q2_5",
                                                id: "q2_5_a2"
                                            }, null, 512), [
                                                [_vModelRadio, tempForm.account_type]
                                            ]),
                                            _cache[48] || (_cache[48] = _createElementVNode("label", {
                                                for: "q2_5_a2",
                                                style: { "margin-left": "6px" }
                                            }, "当座", -1)),
                                            _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
                                            (validate.shot && ((_f = props.errors) === null || _f === void 0 ? void 0 : _f.account_type))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(props.errors.account_type), 1))
                                                : _createCommentVNode("", true),
                                            _cache[50] || (_cache[50] = _createElementVNode("p", { class: "sub_t" }, "口座名義", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((tempForm.account_holder) = $event)),
                                                type: "text",
                                                name: "q2_7",
                                                class: "f_corp w50 inquiry-form",
                                                placeholder: "例：ﾔﾏﾀﾞ ﾀﾛｳ"
                                            }, null, 512), [
                                                [_vModelText, tempForm.account_holder]
                                            ]),
                                            _cache[51] || (_cache[51] = _createElementVNode("span", null, "（半角ｶﾅ）", -1)),
                                            _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1)),
                                            (validate.shot && ((_g = props.errors) === null || _g === void 0 ? void 0 : _g.account_holder))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(props.errors.account_holder), 1))
                                                : _createCommentVNode("", true),
                                            _cache[53] || (_cache[53] = _createElementVNode("p", { class: "sub_t" }, "口座番号", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((tempForm.account_number) = $event)),
                                                type: "text",
                                                name: "q2_8",
                                                class: "f_corp w40 inquiry-form",
                                                placeholder: "例：0000000",
                                                maxlength: "7"
                                            }, null, 512), [
                                                [_vModelText, tempForm.account_number]
                                            ]),
                                            _cache[54] || (_cache[54] = _createElementVNode("span", null, "（半角数字7桁）", -1)),
                                            _cache[55] || (_cache[55] = _createElementVNode("br", null, null, -1)),
                                            _cache[56] || (_cache[56] = _createElementVNode("span", null, "6桁の口座をお持ちの方は左に0を追加して7桁でご入力ください。", -1)),
                                            (validate.shot && ((_h = props.errors) === null || _h === void 0 ? void 0 : _h.account_number))
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(props.errors.account_number), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", { class: "bt_box clear" }, [
                                            _createElementVNode("ul", { class: "modalBtn-area b2" }, [
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("p", {
                                                        class: "bt_modal_close bt_clear",
                                                        onClick: onClickCancel
                                                    }, "キャンセル")
                                                ]),
                                                _createElementVNode("li", null, [
                                                    _createElementVNode("p", {
                                                        class: "bt_ok",
                                                        onClick: onClickOk
                                                    }, "OK")
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
